export default {"src":"/_next/static/media/amex.85fd93ec.svg","height":32,"width":49,"blurWidth":0,"blurHeight":0};